import { useState } from 'react';
import { FileSpreadsheet, FileText, FileBarChart } from 'lucide-react';
import ReportingLefeuvre from './ReportingLefeuvre';

export default function Reporting() {
  const [activeTab, setActiveTab] = useState<'general' | 'lefeuvre' | 'uff'>('general');

  return (
    <div className="space-y-6">

      {/* ── Header ── */}
      <div className="relative rounded-2xl overflow-hidden bg-gradient-to-r from-slate-800 via-slate-900 to-indigo-950 shadow-lg">
        <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-500/10 rounded-full -translate-y-1/2 translate-x-1/3 pointer-events-none" />
        <div className="absolute bottom-0 right-32 w-40 h-40 bg-violet-500/10 rounded-full translate-y-1/2 pointer-events-none" />

        {/* Title row */}
        <div className="relative px-7 pt-6 pb-4 flex items-center gap-4">
          <div className="w-12 h-12 rounded-2xl bg-white/10 border border-white/15 flex items-center justify-center shrink-0">
            <FileSpreadsheet size={22} className="text-indigo-300" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-white tracking-tight">Reporting</h1>
            <p className="text-sm text-slate-400 mt-0.5">Rapports et analyses consolidés</p>
          </div>
        </div>

        {/* Tab bar */}
        <div className="relative px-7 pb-4 flex items-center gap-1 border-t border-white/10 pt-3">
          {([
            { id: 'general'   as const, label: 'Reporting Général',  Icon: FileSpreadsheet },
            { id: 'lefeuvre'  as const, label: 'Reporting Lefeuvre', Icon: FileText        },
            { id: 'uff'       as const, label: 'Reporting UFF',      Icon: FileBarChart    },
          ] as const).map(({ id, label, Icon }) => (
            <button
              key={id}
              onClick={() => setActiveTab(id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition-all ${
                activeTab === id
                  ? 'bg-white text-slate-800 shadow-sm'
                  : 'text-white/55 hover:text-white hover:bg-white/10'
              }`}
            >
              <Icon size={15} />
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* ── Tab Content ── */}
      {activeTab === 'general' && (
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
          <p className="text-sm text-slate-500">Contenu à venir…</p>
        </div>
      )}
      {activeTab === 'lefeuvre' && <ReportingLefeuvre />}
      {activeTab === 'uff' && (
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
          <p className="text-sm text-slate-500">Contenu à venir…</p>
        </div>
      )}
    </div>
  );
}
